import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { SupportCategorySelector } from '@bingads-webui-react/support-category-selector';
import { withActivityContext } from '@bingads-webui-react/hoc-with-signal';

class RequestCallFormInternal extends React.Component {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
      getCldr: PropTypes.func,
    }).isRequired,
    featureName: PropTypes.string,
    permissions: PropTypes.shape({}),
    resourcePath: PropTypes.string,
    activity: PropTypes.shape({
      signal: PropTypes.func,
      trace: PropTypes.func,
    }),
    logger: PropTypes.shape({
      trace: PropTypes.func,
      error: PropTypes.func,
    }),
    context: PropTypes.shape({
      accountNumber: PropTypes.string,
      flowId: PropTypes.string,
    }),
  }

  static defaultProps = {
    featureName: '',
    permissions: {},
    activity: { signal: _.noop, trace: _.noop },
    logger: { trace: _.noop, error: _.noop },
    resourcePath: 'https://ui.ads.microsoft.com/campaign/virtualagent',
    context: {
      accountNumber: '',
      flowId: 'advertiser',
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      issue: '-1',
    };
  }

  handleSubmit = () => {
    const { language, region } = this.props.i18n.getCldr().attributes;
    const contextArray = [
      { name: 'account number', value: this.props.context.accountNumber },
    ];
    window.open(
      `${this.props.resourcePath}?locale=${language}-${region}&virtual=false&modality=callback&issue=${this.state.issue}&context=${encodeURIComponent(JSON.stringify(contextArray))}&flowid=${this.props.context.flowId || 'advertiser'}`,
      '_blank',
      'width=360,height=480,resizable=1,scrollbars=1'
    );
    this.props.onSuccess();
    this.props.activity.signal('onSubmit: open a new window');
    this.props.activity.signal(`issue: ${this.state.issue}`);
    this.props.logger.trace('Request-call-modal: handleSubmit', 'onSubmit: open a new window');
    this.props.logger.trace('Request-call-modal: handleSubmit', `issue: ${this.state.issue}`);
  }

  handleSelectChange = (issue) => {
    this.setState({
      issue,
      isLoading: issue === '-1',
    });
  }

  render() {
    this.props.activity.signal('RequestCallFormInternal render');
    this.props.logger.trace('Request-call-modal: render', 'RequestCallFormInternal render');

    return (
      <div className="request-call-form">
        <div className="request-call-form-header">
          <button className="close" aria-label={this.props.i18n.getString('RequestCallModal_Close')} onClick={this.props.onCancel}>
            <span aria-hidden="true" className="closeimage iconba iconba-Cancel" />
          </button>
          <div id="msSupportRequestCallFormTitle" role="heading" aria-level="3">{this.props.i18n.getString('RequestCallModal_CallMeBack')}</div>
        </div>

        <div className="request-call-form-body">
          <SupportCategorySelector
            i18n={this.props.i18n}
            onMount={this.handleSelectChange}
            onSelectChange={this.handleSelectChange}
            featureName={this.props.featureName}
            permissions={this.props.permissions}
          />
        </div>

        <div className="request-call-form-footer">
          <button className="btn btn-primary" data-analyticsid="request-call-form_continue" onClick={this.handleSubmit} disabled={this.state.isLoading}>{this.props.i18n.getString('RequestCallModal_Continue')}</button>
          <button className="btn btn-default" data-analyticsid="request-call-form_cancel" onClick={this.props.onCancel}>{this.props.i18n.getString('RequestCallModal_Cancel')}</button>
        </div>
      </div>
    );
  }
}

export const RequestCallForm = withActivityContext(RequestCallFormInternal);
